/**
 * A boolean as display text: "True" or "False".
 *
 * Every place the app shows a boolean value to a reader — filter chips, chart
 * legends, table cells, summaries — uses this, so the same value never reads
 * "true" in one place and "True" in another. Capitalized, as the value is
 * spelled in Python and in the filter picker's own labels.
 */
export function formatBoolean(value: boolean): "True" | "False" {
  return value ? "True" : "False";
}
